/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Updated_AtInputs */

const cs_order_updated_at = /** @type {(inputs: Order_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizace`)
};

const en_order_updated_at = /** @type {(inputs: Order_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Order_Updated_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_updated_at = /** @type {((inputs?: Order_Updated_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Updated_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_updated_at(inputs)
	return cs_order_updated_at(inputs)
});